import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 p-2" }, "Você não descreveu esse este fluxo.", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-left"
}
const _hoisted_3 = { class: "p-2" }

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import Textarea from '@/components/ui/textarea/Textarea.vue';
import { Info } from 'lucide-vue-next';
import Button from '@/components/ui/button/Button.vue';
import { PropType, ref, watch } from 'vue';
import { patchWorkflow, Workflow } from '@/http/workflow';
import { useStore } from 'vuex';
import { GET_CREDENTIALS } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoDropdown',
  props: {
    "selectedWorkflow": {
  type: Object as PropType<Workflow | undefined>,
  required: true,
  default: undefined
},
    "selectedWorkflowModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels([
  'refresh-workflow-on-list'
], ["update:selectedWorkflow"]),
  setup(__props, { emit: __emit }) {

const selectedWorkflow = _useModel(__props, 'selectedWorkflow');

watch(selectedWorkflow, () => {
  newNoteForWorkflow.value = undefined;
  isAddingNewNote.value = false;
});

const isAddingNewNote = ref(false);
const newNoteForWorkflow = ref<string | undefined>(undefined);

const store = useStore();

const emit = __emit;

const tryToSaveNote = async () => {
  const workflowId = selectedWorkflow.value?.id;
  const credentials = store.getters[GET_CREDENTIALS];
  let noteTrimmed = newNoteForWorkflow.value?.trim();

  if (noteTrimmed === "") noteTrimmed = undefined;
  if (workflowId === undefined) return;

  const payload = { "notes": noteTrimmed };
  await patchWorkflow(workflowId, payload, credentials);
  newNoteForWorkflow.value = undefined;
  isAddingNewNote.value = false;
  emit('refresh-workflow-on-list', workflowId);
};


return (_ctx: any,_cache: any) => {
  return (selectedWorkflow.value !== undefined)
    ? (_openBlock(), _createBlock(_unref(DropdownMenu), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenuTrigger), null, {
            default: _withCtx(() => [
              _createVNode(Button, {
                variant: "ghost",
                class: "p-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Info), { class: "text-muted" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuContent), { class: "bg-white mt-4 w-60" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DropdownMenuLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode("Descrição")
                ]),
                _: 1
              }),
              _createVNode(_unref(DropdownMenuSeparator), { class: "bg-gray-300" }),
              (selectedWorkflow.value.notes === null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["flex flex-col", { 'hidden': isAddingNewNote.value }])
                  }, [
                    _hoisted_1,
                    _createVNode(Button, {
                      onClick: _cache[0] || (_cache[0] = () => isAddingNewNote.value = true)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Adicionar")
                      ]),
                      _: 1
                    })
                  ], 2))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(selectedWorkflow.value.notes), 1)
                  ])),
              _createElementVNode("div", {
                class: _normalizeClass(["p-2 text-right", { 'hidden': !isAddingNewNote.value }])
              }, [
                _createVNode(Textarea, {
                  class: "min-h-28 mb-2",
                  name: "new-note",
                  id: "new-note",
                  modelValue: newNoteForWorkflow.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newNoteForWorkflow).value = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(Button, {
                  variant: "ghost",
                  onClick: _cache[2] || (_cache[2] = () => isAddingNewNote.value = false)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar")
                  ]),
                  _: 1
                }),
                _createVNode(Button, { onClick: tryToSaveNote }, {
                  default: _withCtx(() => [
                    _createTextVNode("Salvar")
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})